import { IncidentCommunicationModal } from "./IncidentCommunicationModal";

export default IncidentCommunicationModal;
